import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const PageHeader = ({ 
  title, 
  subtitle = null,
  icon = null,
  actions = []
}) => {
  return (
    <Box sx={{
      mb: { xs: 2, sm: 4 },
      pb: 2,
      borderBottom: '2px solid',
      borderColor: 'primary.main'
    }}>
      {/* Main header row */}
      <Stack 
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={2}
      >
        {/* Title section */}
        <Stack direction="row" alignItems="center" spacing={1}>
          {icon && (
            <Box sx={{ 
              fontSize: '28px',
              color: 'primary.main'
            }}>
              {icon}
            </Box>
          )}
          <Box>
            <Typography 
              variant="h4" 
              component="h1"
              sx={{ 
                fontWeight: 700,
                color: 'text.primary',
                fontSize: { xs: '1.5rem', sm: '2rem' }
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'text.secondary',
                  mt: 0.5
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>

        {/* Actions section */}
        {actions && actions.length > 0 && (
          <Stack 
            direction="row" 
            spacing={1}
            sx={{ 
              flexShrink: 0,
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            {actions.map((action, index) => (
              <Box key={index}>
                {action}
              </Box>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default PageHeader;